import { isValidJSON } from 'src/helpers/validators';
import { mobileEvents } from './mobile-events';
import { on_back } from 'src/helpers/back_button_helper';
import { update_files_mobile } from './http';

window.update_files = (ip: string) => {
	console.log('update_files_pls:', ip);
	update_files_mobile(ip);
};

class Mobile extends EventTarget {
	constructor() {
		super();
		window.mobile = new Proxy(
			{},
			{
				get: (_target, name) => {
					return (...args) => {
						// console.warn('mobile.name', name);
						if (
							name == 'back_button' &&
							this.dispatchEvent(new CustomEvent(name.toString(), { cancelable: true }))
						) {
							on_back();
						} else {
							if (mobileEvents[name]) {
								mobileEvents[name].apply(mobileEvents, args);
							}
							this.dispatchEvent(new CustomEvent(name.toString(), { detail: args }));
						}
						console.log(
							'mobile ⛏',
							'name:',
							name,
							'args:',
							isValidJSON(args[0]) ? JSON.parse(args[0]) : args[0],
						);
					};
				},
			},
		);
	}
	public exec(params: string) {
		const xhr = new XMLHttpRequest();
		xhr.open('GET', `shelly://${params}`);
		xhr.setRequestHeader('Cache-Control', 'no-cache');
		xhr.send();
	}
	public get isMobile() {
		return navigator.userAgent.match('Shelly') && !navigator.userAgent.match('ShellyStargate');
	}
	public get OS() {
		try {
			return navigator.userAgent.match(/Android|IOS/)?.[0];
		} catch (e) {
			return '';
		}
	}
}

export const mobile = new Mobile();
